// chakra imports
import {
  Box,
  Divider,
  Flex,
  HStack,
  Icon,
  Image,
  Stack,
  Text,
  Tooltip,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react';
import { InstallmentCalculatorModal } from 'components/InstallmentCalculatorModal';
import Links from 'components/sidebar/components/Links';
import SidebarCard from 'components/sidebar/components/SidebarCard';
import useAuth from 'contexts/useAuth';
import { FaSignOutAlt, FaWhatsapp } from 'react-icons/fa';
import { maskCurrency } from 'utils/number';
import { getVariable } from 'whitelabel';
import { maskAccountNumber } from 'utils/account';
import { MdCopyAll } from 'react-icons/md';
import AccountSwitcher from './AccountSwitcher';
import FeedbackButton from 'components/feedback/FeedbackButton';

// FUNCTIONS

function SidebarContent(props: { routes: RoutesType[]; closeSidebar: () => void }) {
  const { routes } = props;
  const { userData, signOut } = useAuth();
  let textColor = useColorModeValue('gray.200', 'gray.200');

  const AccountInfo = () => {
    return (
      <>
        {' '}
        <Box>
          <Text
            w="100%"
            fontSize="md"
            fontWeight="700"
            color={textColor}
          >
            Olá, {userData?.name}
          </Text>
        </Box>
        <HStack
          w="100%"
          mb="0px"
          alignItems="center"
        >
          <Text
            w="80%"
            fontSize="md"
            fontWeight="700"
            color={textColor}
          >
            Sua conta: {userData?.accountNumber ? maskAccountNumber(userData?.accountNumber) : 'Não informado'}
          </Text>
          <Icon
            as={MdCopyAll}
            color="gray.500"
            w="18px"
            h="18px"
            me="10px"
            cursor="pointer"
            onClick={() => {
              navigator.clipboard.writeText(userData?.accountNumber || '');
            }}
          />
        </HStack>
      </>
    );
  };
  // SIDEBAR
  return (
    <Flex
      direction="column"
      height="100%"
      pt="25px"
      borderRadius="30px"
    >
      <Text
        fontSize={35}
        padding={8}
        color={textColor}
      >
        <VStack mb="5px">
          <Image
            cursor="pointer"
            alt=""
            src={getVariable('logo_inverted')}
            maxWidth={200}
          />
        </VStack>
      </Text>

      <Stack
        direction="column"
        mt="8px"
        mb="auto"
        pb="20"
      >
        <VStack
          alignItems="flex-start"
          pl={8}
          mb={8}
          display={{
            base: 'none',
            md: 'flex',
          }}
        >
          <AccountInfo />
        </VStack>
        <VStack
          alignItems="flex-start"
          pl={8}
          mb={8}
          display={{
            base: 'flex',
            md: 'none',
          }}
        >
          <AccountInfo />
          <Divider />
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
          >
            <Tooltip
              label="Saldo da Conta"
              hasArrow
            >
              <Text
                color="gray.200"
                fontSize="lg"
                fontWeight="bold"
              >
                Saldo disponível: {maskCurrency(userData.balance)}
              </Text>
            </Tooltip>
            <Tooltip
              label="Em liberação"
              hasArrow
            >
              <Text
                color="gray.200"
                fontSize="md"
              >
                Saldo pendente: {maskCurrency(userData.balancePending)}
              </Text>
            </Tooltip>
            <Tooltip
              label="Saldo Bloqueado"
              hasArrow
            >
              <Text
                color="gray.200"
                fontSize="md"
              >
                Saldo bloqueado: {maskCurrency(userData.amountLocked)}
              </Text>
            </Tooltip>
          </Box>
        </VStack>

        <AccountSwitcher />

        <HStack
          mt={2}
          px="16px"
          w="full"
          borderRadius="12px"
          cursor="pointer"
          pr="34px"
        >
          <InstallmentCalculatorModal />
        </HStack>

        <Box
          ps="20px"
          pe={{ lg: '16px', '2xl': '16px' }}
        >
          <Box
            maxHeight={{
              base: 'calc(100vh - 200px)',
              md: 'calc(100vh - 200px)',
            }}
            overflowY="auto"
          >
            <Links
              routes={routes}
              closeSidebar={props.closeSidebar}
            />
          </Box>
          <Box>
            <HStack
              py="5px"
              ps="10px"
              onClick={() => {
                window.open(getVariable('supportWhatsapp'), '_blank');
              }}
              cursor="pointer"
            >
              <Flex
                w="100%"
                alignItems="center"
                justifyContent="center"
              >
                <Box
                  me="18px"
                  alignItems={'center'}
                  display={'flex'}
                  height={'22px'}
                  color={textColor}
                >
                  <FaWhatsapp />
                </Box>
                <Text
                  me="auto"
                  color={textColor}
                  fontWeight="normal"
                >
                  Suporte WhatsApp
                </Text>
              </Flex>
              <Box
                h="36px"
                w="4px"
                bg="transparent"
                borderRadius="5px"
              />
            </HStack>
            <HStack
              py="5px"
              ps="10px"
              onClick={() => signOut(null)}
              cursor="pointer"
            >
              <Flex
                w="100%"
                alignItems="center"
                justifyContent="center"
              >
                <Box
                  me="18px"
                  alignItems={'center'}
                  display={'flex'}
                  height={'22px'}
                  color={textColor}
                >
                  <FaSignOutAlt />
                </Box>
                <Text
                  me="auto"
                  color={textColor}
                  fontWeight="normal"
                >
                  Sair
                </Text>
              </Flex>
              <Box
                h="36px"
                w="4px"
                bg="transparent"
                borderRadius="5px"
              />
            </HStack>
            <Box mt="14px">
              <FeedbackButton />
            </Box>
          </Box>
        </Box>
      </Stack>

      <Box
        ps="20px"
        pe={{ lg: '16px', '2xl': '20px' }}
        mt="60px"
        mb="40px"
        borderRadius="30px"
      >
        <SidebarCard />
      </Box>
    </Flex>
  );
}

export default SidebarContent;
